<template>
  <div class="custom-field">
    <custom-field-label :field="field" />

    <v-combobox
      ref="combobox"
      color="primary"
      variant="outlined"
      v-model="field.value"
      :rules="validationRules"
      :items="field.dropDownValues"
      @update:model-value="value => $emit('input', value || '')"
      :placeholder="field.description"
      clearable
      :menu-props="{ maxHeight }"
      open-on-clear></v-combobox>
  </div>
</template>

<script>
import customFieldTypeMixin from '@/components/custom_fields/mixins/customFieldTypeMixin';
import { isMobile } from '@/util';

export default {
  name: 'custom-field-combobox',
  mixins: [customFieldTypeMixin],
  computed: {
    maxHeight() {
      return isMobile() ? 150 : 500;
    }
  }
};
</script>
